<template>
  <div>
    <vs-popup class="marketplace--item-popup" :title="data.title" :active.sync="detailsPopupActive">
      <div>
        <div class="flex items-start">
          <span class="template-options-btn-icon p-0 inline-flex feather-icon text-primary mr-3"
            :style="{ background: 'transparent'}">
            <img :src="data.icon" width="45px" height="45px" />
          </span>
          <div class="relative m-1">
            <h4 class="mb-1" v-if="data.id === 'coach' && orgData.slug === 'gala'">
              Mentor
            </h4>
            <h4 class="mb-1" v-else-if="data.id === 'coach' && orgData.slug !== 'gala'">
              Coach
            </h4>

            <h4 class="mb-1" v-else>
              {{ data.title }}
            </h4>

            <p>{{ data.shortDescription }}</p>
          </div>
        </div>
        <vs-divider />
        <div class="flex flex-col">
          <p v-html="data.description"></p>
          <vs-button v-if="data.id === 'market'" @click="navigateToMarket()" class="mt-4 self-end">
            Configure
          </vs-button>
        </div>
        <!-- <vs-divider /> -->
        <!-- <div v-if="data.ss1">
            <img :src="data.ss1" width="50%" />
        </div> -->
        <!-- <div class="mt-base">
          <p><b class="info-heading">Help and Support:</b>  help@getboarded.com</p>
        </div> -->
        <div v-if="appConfig[data.id]" class="mt-base">
          <h3 class="mb-base">App Configurations</h3>
          <div v-if="data.id === 'resume-editor'">
            <h4>Resume Templates Configured</h4>
            <div class="vx-row" v-if="organizationId === 'gala'">
              <div class="vx-col w-1/2 items-center">
                <div class="cursor-pointer">
                  <div class="resume-template m-5 mb-base">
                    <img :src="require('@/assets/images/resume-template-thumbnail/charactercard/lighttheme/blue.png')
                      " width="100%" />
                  </div>
                  <h4>Character Card-Light</h4>
                </div>
              </div>

              <div class="vx-col w-1/2 items-center">
                <div class="cursor-pointer">
                  <div class="resume-template m-5 mb-base">
                    <img :src="require('@/assets/images/resume-template-thumbnail/charactercard/darktheme/blue.png')
                      " width="100%" />
                  </div>
                  <h4>Character Card-Dark</h4>
                </div>
              </div>
            </div>
            <div class="vx-row" v-else>
              <div class="vx-col w-1/2 items-center">
                <div class="cursor-pointer">
                  <div class="resume-template m-5 mb-base">
                    <img :src="require('@/assets/images/resume-template-thumbnail/prestige/blue.png')
                      " width="100%" height="100%" />
                  </div>
                  <h4>Prestige</h4>
                </div>
              </div>
              <div class="vx-col w-1/2 items-center">
                <div class="cursor-pointer">
                  <div class="resume-template m-5 mb-base">
                    <img :src="require('@/assets/images/resume-template-thumbnail/greyline/blue.png')
                      " width="100%" height="100%" />
                  </div>
                  <h4>Greyline</h4>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="data.id === 'coach'">
            <div class="vx-row">
              <div class="vx-col w-full lg:w-1/2">
                <vs-row class="mb-base">
                  <label>Coaching Survey</label>
                  <vs-input class="w-full" type="number" v-model="localCoachConfig.coachingSurvey" />
                </vs-row>
                <vs-row class="mb-base">
                  <label>Motivation Survey</label>
                  <vs-input class="w-full" type="number" v-model="localCoachConfig.motivationSurvey" />
                </vs-row>
              </div>
              <div class="vx-col w-full lg:w-1/2 mb-base">
                <vs-row class="mb-base">
                  <label>Feedback Frequency</label>
                  <vs-input class="w-full" type="number" v-model="localCoachConfig.feedbackFrequency" />
                </vs-row>
              </div>
            </div>
            <div>
              <vs-button color="primary" class="ml-auto" :disabled="!localCoachConfig.coachingSurvey ||
                !localCoachConfig.motivationSurvey ||
                !localCoachConfig.feedbackFrequency
                " @click.stop="saveCoachConfigs()">Save</vs-button>
            </div>
          </div>
          <!-- <div v-else-if="data.id === 'hibob'">
            <div class="vx-row">
              <div class="vx-col w-full lg:w-1/2">
                <vs-row class="mb-base">
                  <label>HiBob Api Key</label>
                  <vs-input class="w-full" v-model="localHibobConfig.apiKey" />
                </vs-row>
              </div>
            </div>
            <div>
              <vs-button color="primary" class="ml-auto" :disabled="!localHibobConfig.apiKey"
                @click.stop="saveHibobConfigs()">Save</vs-button>
            </div>
          </div> -->
          <div v-else-if="data.id === 'journey'">
            <journey-steps />
          </div>
        </div>
      </div>
    </vs-popup>
    <div class="marketplace--item cursor-pointer" @click.stop="detailsPopupActive = true">
      <div class="vx-row flex justify-between flex-wrap mb-5">
        <div class="vx-col">
          <span class="template-options-btn-icon p-0 inline-flex feather-icon text-primary mr-3"
            :style="{ background: '', 'border-radius': '0px' }">
            <img :src="icon" width="45px" height="45px" />
          </span>
        </div>
        <div class="vx-col">
          <!-- <vs-button @click.stop="detailsPopupActive=true" color="#44CC88" type="filled">Get</vs-button> -->
        </div>
      </div>

      <h4 class="mb-1" v-if="data.id === 'coach' && orgData.slug === 'gala'">
        Mentor
      </h4>
      <h4 class="mb-1" v-else-if="data.id === 'coach' && orgData.slug !== 'gala'">
        Coach
      </h4>

      <h4 class="mb-1" v-else>
        {{ title }}
      </h4>
      <p v-if="data.shortDescription" class="wrap-text">
        {{ data.shortDescription.substring(0, 80) }}...
      </p>
      <p v-else class="wrap-text">Lorem ipsum dolor sit amet consetetur...</p>
    </div>
  </div>
</template>

<script>
import Details from "../Details.vue";
import coachOrgConfigs from "@/assets/data/coach-configs";
import appConfig from "@/assets/data/app-config";
import _ from "lodash";
import JourneySteps from "./JourneySteps.vue";

export default {
  components: { Details, JourneySteps },
  props: ["title", "description", "icon", "color", "data"],
  data() {
    return {
      detailsPopupActive: false,
      localCoachConfig: JSON.parse(
        JSON.stringify(
          this.orgData &&
            this.orgData.appConfigs &&
            this.orgData.appConfigs.coach
            ? this.orgData.appConfigs.coach
            : {}
        )
      ),
      localHibobConfig: JSON.parse(
        JSON.stringify(
          this.orgData &&
            this.orgData.appConfigs &&
            this.orgData.appConfigs.hibob
            ? this.orgData.appConfigs.hibob
            : {}
        )
      ),
      coachOrgConfigs,
      appConfig,
    };
  },
  computed: {
    organizationId() {
      return this.$route.params.organizationId;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
  },
  watch: {
    orgData() {
      this.localCoachConfig = JSON.parse(
        JSON.stringify(
          this.orgData &&
            this.orgData.appConfigs &&
            this.orgData.appConfigs.coach
            ? this.orgData.appConfigs.coach
            : {}
        )
      );
      this.localHibobConfig = JSON.parse(
        JSON.stringify(
          this.orgData &&
            this.orgData.appConfigs &&
            this.orgData.appConfigs.hibob
            ? this.orgData.appConfigs.hibob
            : {}
        )
      );
    },
  },
  methods: {
    navigateToMarket() {
      const dynamicMarketRoute = `/organization/${this.orgData.slug}/marketplace/config/marketapp`;
      this.$router.push(dynamicMarketRoute);
    },
    saveCoachConfigs() {
      try {
        const coachConfig = _.find(coachOrgConfigs, (cconfig) => {
          return this.organizationId && cconfig.orgSlug === this.organizationId;
        });
        if (!_.isEmpty(coachConfig)) {
          const coachCompanyId = coachConfig.coachCompanyId;
          if (this.orgData.appConfigs) {
            this.$store
              .dispatch("organization/saveCoachConfig", {
                coachCompanyId,
                organizationId: this.orgData._id,
                "appConfigs.coach": this.localCoachConfig,
              })
              .then(() => {
                this.$vs.notify({
                  title: "Coach Configs Saved Successfully",
                });
              });
          } else {
            this.$store
              .dispatch("organization/saveCoachConfig", {
                coachCompanyId,
                organizationId: this.orgData._id,
                appConfigs: {
                  coach: this.localCoachConfig,
                },
              })
              .then(() => {
                this.$vs.notify({
                  title: "Coach Configs Saved Successfully",
                });
              });
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    // saveHibobConfigs() {
    //   try {
    //     if (this.orgData.appConfigs) {
    //       this.$store
    //         .dispatch("organization/saveHibobConfig", {
    //           organizationId: this.orgData._id,
    //           "appConfigs.hibob": this.localHibobConfig,
    //         })
    //         .then(() => {
    //           this.$vs.notify({
    //             title: "Hibob Configs Saved Successfully",
    //           });
    //         });
    //     } else {
    //       this.$store
    //         .dispatch("organization/saveHibobConfig", {
    //           organizationId: this.orgData._id,
    //           appConfigs: {
    //             hibob: this.localHibobConfig,
    //           },
    //         })
    //         .then(() => {
    //           this.$vs.notify({
    //             title: "Hibob Configs Saved Successfully",
    //           });
    //         });
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
  },
  created() {
    if (this.orgData) {
      this.localCoachConfig = JSON.parse(
        JSON.stringify(
          this.orgData &&
            this.orgData.appConfigs &&
            this.orgData.appConfigs.coach
            ? this.orgData.appConfigs.coach
            : {}
        )
      );
      this.localHibobConfig = JSON.parse(
        JSON.stringify(
          this.orgData &&
            this.orgData.appConfigs &&
            this.orgData.appConfigs.hibob
            ? this.orgData.appConfigs.hibob
            : {}
        )
      );
    }
  },
};
</script>

<style scoped>
.marketplace--item {
  box-sizing: border-box;
  border-radius: 6px;
}

.marketplace--item-popup>>>.vs-popup {
  width: 950px;
}

.resume-template {
  height: 470px;
}

.info-heading {
  font-weight: 900 !important;
}

.vs-button {
  border-radius: 6px;
}
</style>
